import { Divider, Link, Popper, Stack } from '@mui/material'
import PropTypes from 'prop-types'
import LinkOffIcon from '@mui/icons-material/LinkOff'
import { useFocused, useSelected, useSlateStatic } from 'slate-react'
import { useTranslation } from 'react-i18next'

import ExternalLink from '@hapana/shared/web/styles/assets/svgs/external-link.svg'
import Button from '../button/button.component'

import { BUTTON_VARIANTS } from '../button/button.constants'

import { styles } from './text-editor.styles'
import { removeLink } from './text-editor.utils'

const TextEditorLink = ({ attributes, children, element }) => {
  const { t } = useTranslation(['common'])
  const { ref } = attributes
  const editor = useSlateStatic()
  const selected = useSelected()
  const focused = useFocused()
  const handleRemoveLink = () => removeLink(editor)
  const open = selected && focused

  return (
    <>
      <Link href={element.href} {...attributes}>
        {children}
      </Link>
      {ref.current && (
        <Popper placement="bottom" open={open} anchorEl={ref.current} contentEditable={false}>
          <Stack
            sx={styles.linkPopper}
            direction="row"
            spacing={2}
            divider={<Divider orientation="vertical" flexItem />}
          >
            <Link href={element.href} underline="none" target="_blank">
              <Button
                type="button"
                variant={BUTTON_VARIANTS.TEXT}
                textPadding={false}
                startIcon={ExternalLink}
              >
                {t('common:openLink')}
              </Button>
            </Link>
            <Button
              type="button"
              variant={BUTTON_VARIANTS.TEXT}
              textPadding={false}
              onClick={handleRemoveLink}
              startIcon={LinkOffIcon}
            >
              {t('common:removeLink')}
            </Button>
          </Stack>
        </Popper>
      )}
    </>
  )
}

TextEditorLink.propTypes = {
  attributes: PropTypes.object,
  children: PropTypes.arrayOf(PropTypes.node),
  element: PropTypes.shape({
    href: PropTypes.string,
  }),
}
export default TextEditorLink
